<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="property" label-position="top">
        <el-form-item label="Propriedade" prop="property">
            <el-input type="text" v-model="property.property"  />
        </el-form-item>
        <el-form-item label="Valor" prop="value">
            <el-input type="text" v-model="property.value"  />
        </el-form-item>


        <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Salvar
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Property, User } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useRoute } from "vue-router"
    import { useStore } from "vuex"

    const store = useStore()
    const route = useRoute()
    const property = reactive<Property>({
        property: 'propriedade',
        value: 'Valor'
    })

    const required = true
    const rules = reactive<FormRules<Property>>({
        property: [{required, message: 'Insira o nome da propriedade'}],
        value: [{required, message: 'Insira um valor'}]
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post('admin/products/' + route.params.id, property)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Adicionada com sucesso'})
                    store.commit('setOpenModal', -1)
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
